import type { RouteRecordRaw } from 'vue-router';
import ChildRiderPage from './ChildRiderPage.vue';
import DashboardLayout from '@/layouts/DashboardLayout.vue';
import { RouteNames } from '@/router/routeNames';

const routes: RouteRecordRaw = {
  path: '/childrider',
  component: DashboardLayout,
  children: [
    {
      name: RouteNames.CHILD_RIDER,
      path: '',
      component: ChildRiderPage,
      meta: {
        pageTitle: 'Landing.ChildRider',
      },
    },
  ],
};

export default routes;
